export const STRING = "STRING";
export const NUMBER = "NUMBER";
export const SELECT = "SELECT";
export const UPLOAD = "UPLOAD";
export const DATE = "DATE";
export const KOMMENT = "KOMMENT";
export const CHECKBOX = "CHECKBOX";
